export type Verdict = "BUY" | "WATCH" | "AVOID";
export type DemoPanel = "analysis" | "x" | "solscan" | "tracked";
export interface DemoAnalysis {
  verdict: Verdict;
  score: number;
  confidence: number;
  summary: string;
  checks: readonly string[];
}
export const DEMO_ANALYSES: Record<Verdict, DemoAnalysis> = {
  BUY: {
    verdict: "BUY",
    score: 18,
    confidence: 86,
    summary: "The available demo checks pass the configured risk filters.",
    checks: ["Mint disabled", "Freeze disabled", "Liquidity observed"],
  },
  WATCH: {
    verdict: "WATCH",
    score: 46,
    confidence: 72,
    summary:
      "Some signals need monitoring before making an independent decision.",
    checks: [
      "Holder concentration elevated",
      "Token age: 5 days",
      "No critical block",
    ],
  },
  AVOID: {
    verdict: "AVOID",
    score: 88,
    confidence: 91,
    summary: "A critical demo signal exceeds the configured risk threshold.",
    checks: [
      "Mint authority active",
      "Liquidity is low",
      "Creator history flagged",
    ],
  },
};
export const DEMO_TOKENS = [
  { symbol: "WIF", score: 24, change: -2, alert: "No new alerts" },
  { symbol: "BONK", score: 31, change: 5, alert: "Risk score changed" },
  { symbol: "POPCAT", score: 43, change: 0, alert: "Liquidity check due" },
] as const;
